import React, { createContext, useState, ReactNode } from 'react';

interface FilterContextType {
  filtering: boolean;
  setFiltering: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FilterContext = createContext<FilterContextType | null>(null);

interface FilterProviderProps {
  children: ReactNode;
}

export default function FilterProvider({ children }: FilterProviderProps) {
  const [value, setValue] = useState<boolean>(false);

  return (
    <FilterContext.Provider value={{ filtering: value, setFiltering: setValue }}>
      {children}
    </FilterContext.Provider>
  );
}
